module.exports = __webpack_public_path__ + "img/7coin.4ae656c4.png";